import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function CheckboxUnselectedIcon({
  className,
  fill,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 18}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 18}
    >
      <g
        fill={fill ?? 'currentColor'}
        transform="translate(-1169 -232) translate(1160 228) translate(9 4)"
      >
        <path d="M18.438 19.688c.69 0 1.25-.56 1.25-1.25V5.563c0-.69-.56-1.25-1.25-1.25H5.563c-.69 0-1.25.56-1.25 1.25v12.875c0 .69.56 1.25 1.25 1.25h12.875zm0 1.5H5.563c-1.52 0-2.75-1.232-2.75-2.75V5.563c0-1.52 1.23-2.75 2.75-2.75h12.875c1.518 0 2.75 1.23 2.75 2.75v12.875c0 1.518-1.232 2.75-2.75 2.75z" />
      </g>
    </SimpleIcon>
  );
}
